import React from 'react';
import { Alert } from '@economic/taco';
import { ValidationErrors } from 'final-form';
import { t } from '@lingui/macro';

interface Props {
    errors: ValidationErrors;
    shouldShowConvertToInvoiceButton: boolean;
    hasDraftPartialInvoices: boolean;
}

export default function ErrorMessageAlert({ errors, shouldShowConvertToInvoiceButton, hasDraftPartialInvoices }: Props) {
    const hasMaxValueError =
        errors !== undefined &&
        Object.keys(errors).some(key => {
            return key.startsWith('newQuantity-') && errors[key] === 'maxValueError';
        });

    let errorMessage: string | null = null;
    if (hasMaxValueError) {
        errorMessage = t`The number on the partial invoice exceeds the number in the order`;
    } else if (shouldShowConvertToInvoiceButton && hasDraftPartialInvoices) {
        errorMessage = t`This order cannot be converted to an invoice, since one or more partial invoices have not been booked.`;
    }
    if (errorMessage !== null) {
        return (
            <Alert state="error" className="mt-2">
                {errorMessage}
            </Alert>
        );
    }
    return null;
}
